export class MsgCampaign {
  msgCampaignId: number;
  name: string;
  description: string;
  status: number;
  type: string;
  sendOnDate: Date;
  sendByEmail: boolean;
  sendBySms: boolean;
  senderName: string;
  senderEmail: string;
  senderMobileNum: string;
  senderCountryCode: string;
  subject: string;
  preheader: string;
  emailHtml: string;
  emailText: string;
  mobileText: string;
  headers: string;
  statusMsg: string;
  confId: string;
  trackingId: string;
  opsNotes: string;
  attachments: any[];
  travelAgentProfile: boolean;
  travelAgentPortalAccess: number;
}
